import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogMold } from "../../../models/CatalogMold";
type Props = {
  setMold: (mold: CatalogMold) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewMold: () => void;
};
export const useMoldOptionsFunctions = ({
  setMold,
  setShowModal,
  handleNewMold,
}: Props) => {
  const getMenuOptions = (data: CatalogMold) => {
    let options: MenuOptionType[] = [
      {
        name: "New Mold",
        key: "new_mold",
        onClick: () => {
          handleNewMold();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Mold",
          key: "edit_mold",
          onClick: () => {
            setMold(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Mold",
          key: "delete_mold",
          onClick: () => {
            setMold(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
